import React from 'react';

const DebugUtils = React.forwardRef(({}, ref) => {
  return (
    <div id="debugger" ref={ref} className={`fixed z-[9999999]
      hidden opacity-40
      top-2 left-1/2 transform -translate-x-1/2 px-4 py-2 w-full md:w-[600px]
      text-left
      border-2 border-pink-600 bg-white text-black
      pointer-events-none
      `}>
        progress in seconds = 0.000
    </div>
  );
});

export default DebugUtils;
